import { defineComponent } from '@vue/composition-api';
export default defineComponent({
    props: {
        type: {
            type: String,
            default: 'simple'
        }
    }
});
